import classNames from 'classnames';
import styles from './index.module.scss';
import {MouseEventHandler, useCallback, useEffect, useRef, useState} from 'react';
import Dialog from '@/components/Dialog';
import CloseX from '@/components/CloseX';
import Avatar, {AvatarSize} from '@/components/Avatar';
import Anchor from '@/components/Anchor';
import {useHistory} from 'react-router-dom';
import routers, {buildPath} from '@/config/routers';
import {IFragmentInfo, IMysteryInfo, MysteryBgMap, MysteryType} from '@/domains/user/common/mysteryBox/const';
import {Fragment} from '@/domains/user/common/mysteryBox';
import ReactDOM from 'react-dom';
import {closeMysteryBoxDialog, openMysteryBoxSuccess, showMysteryBoxDialog} from '@/buried/home';
import sdk from '@/sdk';
import toast, {ToastType} from '@/components/Toast';
import {FindTabs} from '@/Constant';
import {HASH} from '@/constants/common/hash';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import ShareDoc, {IDocShareInfo} from '../ShareDoc';

interface MysteryBoxDialogProps {
    receiverUserGuid: string;
    receiverName: string;
    boxGuid: string;
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docShare: IDocShareInfo;
    onClose?: () => void;
}

const highQualityPageUrl = buildPath(routers.FindPage, {tab: FindTabs.highQuality});
const SHOW_DURATION = 10 * 1000;

// const {
//     useIsInGray: useIsChristmasRelease,
// } = initGray(GRAY_RELEASE_KEYS.mysteryBoxChristmas);

const getIsChristmasPrize = (prize: IMysteryInfo) => {
    const {prizeKey} = prize;
    return [
        MysteryType.chris150,
        MysteryType.chris200,
        MysteryType.chris20,
    // @ts-ignore
    ].includes(prizeKey);
};
const getWholePrizeTitle = (prize: IMysteryInfo) => {
    const isChristmasPrize = getIsChristmasPrize(prize);
    if (isChristmasPrize) {
        return '获得圣诞跨年专属奖品';
    }
    return '获得可兑换知识币';
};

const getFragmentPrizeTitle = (prize: IMysteryInfo) => {
    const isChristmasPrize = getIsChristmasPrize(prize);
    const isCompleted = prize.fragmentInfo.collectedCount === prize.fragmentInfo.targetCount;
    if (isChristmasPrize) {
        if (isCompleted) {
            return '圣诞跨年专属碎片已集齐';
        }
        return '获得圣诞跨年专属碎片';
    }
    if (isCompleted) {
        return '碎片已集齐';
    }
    return '获得一块碎片';
};

interface IAnimationTimer {
    closeFirstModal?: NodeJS.Timeout;
    showFlowers?: NodeJS.Timeout;
    hideFlowers?: NodeJS.Timeout;
}
function MysteryBoxDialog(props: MysteryBoxDialogProps) {
    const {receiverUserGuid, receiverName, boxGuid, docShare, onClose, ...repository} = props;
    // const isChristmas = useIsChristmasRelease();
    const [showFirstDialog, setShowFirstDialog] = useState(true);
    const [showSecondDialog, setSecondDialog] = useState(false);
    const [prize, setPrize] = useState<IMysteryInfo | null>(null);
    const firstHandle = useRef<NodeJS.Timeout | null>(null);
    const secHandle = useRef<NodeJS.Timeout | null>(null);
    const openFlag = useRef(false);
    const timerRef = useRef<IAnimationTimer>({});
    const [showGif, setShowGif] = useState(false);

    const handleFirstDialogCancel = useCallback(() => {
        setShowFirstDialog(false);
        onClose && onClose();
        closeMysteryBoxDialog();
    }, [onClose]);

    useEffect(() => {
        firstHandle.current = setTimeout(() => {
            handleFirstDialogCancel();
        }, SHOW_DURATION);
        return () => {
            firstHandle.current && clearTimeout(firstHandle.current);
        };
    }, [handleFirstDialogCancel]);

    const handleSecondDialogCancel = useCallback(() => {
        setSecondDialog(false);
        onClose && onClose();
    }, [onClose]);

    useEffect(() => {
        if (showSecondDialog) {
            firstHandle.current && clearTimeout(firstHandle.current);
        }
    }, [showSecondDialog]);

    const handleFindMoreArticleLogger:MouseEventHandler<HTMLAnchorElement> = (e) => {
        window.open(highQualityPageUrl);
        onClose && onClose();
    };


    const getProgress = useCallback((prize: IMysteryInfo) => {
        const {
            prizeKey,
            name,
            fragmentInfo,
        } = prize;
        const {collectedCount, targetCount} = fragmentInfo;
        // 一片碎片即集齐
        if (targetCount === 1) {
            return <div className={styles.infoWrapper}>
                <p>恭喜你！成功获得一枚{name}！</p>
                <p className={styles.tips}>Tips：可用知识币可投给高价值文档，若不使用每周会定期清零</p>
            </div>;
        }
        // 多个碎片 未集齐
        if (collectedCount < targetCount) {
            return <div className={styles.infoWrapper}>
                <p>收获一块<span className={styles.prizename}>「{name}」</span>碎片！</p>
                <p className={styles.progress}>收集进度：{collectedCount}/{targetCount}</p>
            </div>;
        }
        // 多个碎片 已集齐
        return <div className={styles.infoWrapper}>
            <p>恭喜你！成功拼成完整知识币！</p>
            <p className={styles.progress}>收集进度：{collectedCount}/{targetCount}</p>
        </div>;

    }, []);

    const goToFragmentPage = useCallback(() => {
        const personalPageUrl = buildPath(routers.PersonalHome.path, {
            userName: sdk.as.user?.avatar || '',
        });
        onClose && onClose();
        window.open(`${personalPageUrl}#${HASH.openMysteryBoxHistory}`);
    }, [onClose]);

    const openBox = useCallback(async () => {
        if (openFlag.current) {
            return;
        }
        try {
            openFlag.current = true;
            const ksServer = await sdk.getKsServer(repository);
            const {
                openResult,
                boxPrize,
            } = await ksServer.openBox(boxGuid);
            openFlag.current = false;
            if (openResult) {
                // @ts-ignore
                // setPrize({
                //     prizeItemGuid: '123',
                //     prizeGuid: 'asfasdf',
                //     prizeKey: MysteryType.coin2,
                //     shapeType: 1,
                //     category: 1,
                //     name: '2枚可兑换知识币',
                //     fragmentInfo: {
                //         collectedCount: 1,
                //         targetCount: 1,
                //     },
                //     amount: 1,
                // });
                // setPrize({
                //     prizeItemGuid: '123',
                //     prizeGuid: 'asfasdf',
                //     prizeKey: MysteryType.coin15,
                //     shapeType: 2,
                //     category: 1,
                //     name: '150枚可兑换知识币',
                //     fragmentInfo: {
                //         collectedCount: 1,
                //         targetCount: 2,
                //     },
                //     amount: 1,
                // });
                setPrize(boxPrize);
                timerRef.current.closeFirstModal = setTimeout(() => {
                    setShowFirstDialog(false);
                }, 333);
                timerRef.current.showFlowers = setTimeout(() => {
                    setShowGif(true);
                    timerRef.current.hideFlowers = setTimeout(() => {
                        setShowGif(false);
                    }, 860);
                }, 270);
                setSecondDialog(true);
                openMysteryBoxSuccess();
            } else {
                toast({
                    type: ToastType.Info,
                    content: '很遗憾，盲盒里空空如也',
                });
            }

        } catch (e) {
            console.error(e);
            openFlag.current = false;
        }

    }, [boxGuid, repository]);

    useEffect(() => {
        const timeout = timerRef.current;
        return () => {
            timeout?.closeFirstModal && clearTimeout(timeout?.closeFirstModal);
            timeout?.showFlowers && clearTimeout(timeout?.showFlowers);
            timeout?.hideFlowers && clearTimeout(timeout?.hideFlowers);
        };
    }, []);

    const {targetCount, collectedCount} = prize?.fragmentInfo || {};
    const isTotalPrize = targetCount === 1;

    const handleMouseEnter = useCallback(() => {
        firstHandle.current && clearTimeout(firstHandle.current);
        secHandle.current && clearTimeout(secHandle.current);
    }, []);

    const handleMouseLeaveFirst = useCallback(() => {
        firstHandle.current = setTimeout(() => {
            handleFirstDialogCancel();
        }, SHOW_DURATION);
        return () => {
            firstHandle.current && clearTimeout(firstHandle.current);
        };
    }, [handleFirstDialogCancel]);

    const handleMouseLeaveSec = useCallback(() => {
        secHandle.current = setTimeout(() => {
            handleSecondDialogCancel();
        }, SHOW_DURATION);
        return () => {
            secHandle.current && clearTimeout(secHandle.current);
        };
    }, [handleSecondDialogCancel]);

    return (
        <>
            <Dialog
                visible={showFirstDialog}
                className={classNames(styles.dialog, showSecondDialog && styles.firstDialogAnimation)}
                showHeader={false}
                onCancel={handleFirstDialogCancel}
            >
                <div className={styles.wrapper} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeaveFirst}>
                    <CloseX
                        className={styles.close}
                        size={'md'}
                        onClick={handleFirstDialogCancel}
                    />
                    <div className={classNames(
                        styles.inner,
                        styles.openBoxBg
                        // isChristmas && styles.christmas
                    )}
                    >
                        <>
                            <div className={classNames(
                                styles.title,
                                styles.coin
                            )}
                            >赠币成功</div>
                            <div className={styles.receiveWrapper}>
                                <Avatar className={styles.avatar} userGuid={receiverUserGuid} size={AvatarSize.SM} />
                                <span className={styles.creator}>{receiverName} </span>
                                已收到你的认可
                            </div>
                            <p className={styles.linkToMore}>
                                <span onClick={handleFindMoreArticleLogger}>发现更多好文</span>
                            </p>
                        </>
                        <div className={styles.congratulation}>恭喜！</div>
                        <div className={styles.descGet}>获得一份盲盒，快点击打开</div>
                        <div
                            className={classNames(
                                styles.giftWrapper,
                                showSecondDialog && styles.mysteryBoxAnimation
                                // isChristmas && styles.christmas
                            )}
                            onClick={openBox}
                        >
                            <div className={classNames(styles.hand)}></div>
                        </div>
                    </div>
                </div>
            </Dialog>
            <Dialog
                visible={showSecondDialog}
                className={classNames(styles.dialog, styles.secondDialog)}
                showHeader={false}
                onCancel={handleSecondDialogCancel}
            >
                <div
                    className={classNames(styles.wrapper, styles.secondDialogAnimation)}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeaveSec}
                >
                    <CloseX
                        className={styles.close}
                        size={'md'}
                        onClick={handleSecondDialogCancel}
                    />
                    <div
                        className={styles.inner}
                        style={{
                        // eslint-disable-next-line max-len, @typescript-eslint/no-require-imports
                            backgroundImage: `url("${require(`@/assets/img/mysteryBox/${MysteryBgMap[prize?.prizeKey || MysteryType.coin2]}`)}")`,
                        }}
                    >
                        {
                            isTotalPrize ? <>
                                <div className={classNames(styles.title, styles.noCoin)}>{
                                    prize && getWholePrizeTitle(prize)
                                }</div>
                                <div className={classNames(
                                    (prize?.prizeKey === MysteryType.chris20) && styles.specPrize
                                )}
                                >
                                    {prize && <Fragment className={styles.totalPrize} {...prize} />}
                                </div>
                                <div className={styles.desc}>
                                    收获<span className={styles.prizename}>「{prize?.name}」</span>!
                                </div>
                            </> : <>
                                <div
                                    className={classNames(styles.title, styles.noCoin)}
                                >
                                    {
                                        prize && getFragmentPrizeTitle(prize)
                                    }
                                </div>
                                <div className={styles.giftWrap}>
                                    {prize && <Fragment
                                        className={styles.mysteryBoxGiftAnimation}
                                        {...prize}
                                        needTransitAnimation
                                    />}
                                    {
                                        showGif &&
                                        <div className={styles.flowersAnimation}></div>
                                    }
                                </div>
                                {
                                    prize && getProgress(prize)
                                }
                            </>
                        }
                        <div className={styles.link} onClick={goToFragmentPage}>去个人主页查看我的盲盒奖励</div>
                    </div>
                    {/* <ShareDoc
                        docShareInfo={docShare}
                        onCloseMysteryBoxDialog={handleSecondDialogCancel}
                    /> */}
                </div>
            </Dialog>
        </>
    );
}


export const showMysteryBox = (props: MysteryBoxDialogProps) => {
    const container = document.createElement('div');
    container.className = 'mystery-dialog-container';
    document.body.appendChild(container);

    const destroy = () => {
        ReactDOM.unmountComponentAtNode(container);
        document.body.removeChild(container);
    };

    ReactDOM.render(
        <MysteryBoxDialog {...props} onClose={destroy} />,
        container
    );

    showMysteryBoxDialog();
};


